import { makeHook } from "../../utils/makeSingleArgHook";
import getAuthzCheckBatch, { url, } from "../requests/getAuthzCheckBatch";
export const keyMaker = (check) => [
    check.action,
    check.resources.map((r) => r.type).join(","),
    check.resources.map((r) => r.id).join(","),
    url(),
];
const useCheckPermissionsBatch = makeHook(getAuthzCheckBatch, keyMaker);
export default useCheckPermissionsBatch;
//# sourceMappingURL=useCheckPermissionBatch.js.map